import jwt_decode from 'jwt-decode'

import { IJWT } from '../api/axiosAuth'
import { IRoleEnum } from '../types/router'

export const clearLocalStorage = () => {
    ;['accessToken', 'refreshToken'].forEach((item) =>
        localStorage.removeItem(item)
    )
}

export const hasPermission = (roles: IRoleEnum[]) => {
    const accessToken = localStorage.getItem('accessToken')

    if (!accessToken) return

    const decodedJWT = jwt_decode(accessToken) as IJWT
    return roles.includes(decodedJWT.subject.role)
}

export const getRole = (role: IRoleEnum) => {
    switch (role) {
        case IRoleEnum.ADMIN:
            return 'ADMIN'
        case IRoleEnum.USER:
            return 'USER'
    }
}
